export const PORTFOLIO_PROJECT_LIST_KEY = 'portfolioProjectList'

export const PORTFOLIO_PROJECT_KEY = 'portfolioProject'
